import { CityState } from './types';

export interface Quest {
  id: string;
  title: string;
  description: string;
  rewardXp: number;
  rewardCash: number;
  isCompleted: boolean;
  progressText: string;
  target: number;
  current: number;
}

export class QuestEngine {
  private quests: Quest[] = [];

  constructor() {
    this.initQuests();
  }

  private initQuests() {
    this.quests = [
      {
        id: 'q_roads',
        title: 'Asse Viario di Swisslandia',
        description: 'Amplia la rete stradale cittadina per collegare nuovi quartieri. Costruisci almeno 35 segmenti stradali.',
        rewardXp: 40,
        rewardCash: 350,
        isCompleted: false,
        progressText: '0 / 35 Strade',
        target: 35,
        current: 0
      },
      {
        id: 'q_pop',
        title: 'Calamita Demografica',
        description: 'Zona quartieri residenziali accoglienti e fornisci elettricità/acqua. Raggiungi 30 abitanti.',
        rewardXp: 50,
        rewardCash: 500,
        isCompleted: false,
        progressText: '0 / 30 Abitanti',
        target: 30,
        current: 0
      },
      {
        id: 'q_parks',
        title: 'Polmone Verde',
        description: 'I parchi attirano residenti, aumentano la felicità e i valori del terreno. Costruisci almeno 4 Parchi.',
        rewardXp: 60,
        rewardCash: 400,
        isCompleted: false,
        progressText: '0 / 4 Parchi',
        target: 4,
        current: 0
      },
      {
        id: 'q_safety',
        title: 'Legge e Ordine',
        description: 'Garantisci un elevato tasso di sicurezza in città. Raggiungi un livello di felicità generale dell\'88%.',
        rewardXp: 80,
        rewardCash: 600,
        isCompleted: false,
        progressText: '0 / 88% Felicità',
        target: 88,
        current: 0
      },
      {
        id: 'q_industry',
        title: 'Swiss Hi-Tech',
        description: 'Costruisci e alimenta le aree produttive industriali della città. Raggiungi 15 posti di lavoro totali.',
        rewardXp: 70,
        rewardCash: 450,
        isCompleted: false,
        progressText: '0 / 15 Posti di Lavoro',
        target: 15,
        current: 0
      }
    ];
  }

  public getQuests(): Quest[] {
    return this.quests;
  }

  /**
   * Ticks and checks the active quests state, triggers rewards, logs history and drives Mayor Level Up.
   */
  public tickQuests(state: CityState, addHistoryCallback: (msg: string) => void) {
    const roadsCount = Object.keys(state.roads).length;
    const completedParks = Object.values(state.buildings).filter(b => b.stage === 'completed' && b.zone === 'park').length;
    
    this.quests.forEach((q) => {
      if (q.isCompleted) return;

      // Update current progress values dynamically
      if (q.id === 'q_roads') {
        q.current = roadsCount;
        q.progressText = `${q.current} / ${q.target} Strade`;
      } else if (q.id === 'q_pop') {
        q.current = state.population;
        q.progressText = `${q.current} / ${q.target} Abitanti`;
      } else if (q.id === 'q_parks') {
        q.current = completedParks;
        q.progressText = `${q.current} / ${q.target} Parchi`;
      } else if (q.id === 'q_safety') {
        q.current = state.happiness;
        q.progressText = `${q.current} / ${q.target}% Felicità`;
      } else if (q.id === 'q_industry') {
        q.current = state.jobs;
        q.progressText = `${q.current} / ${q.target} Posti di lavoro`;
      }

      // Check quest completion trigger
      if (q.current >= q.target) {
        q.isCompleted = true;
        
        // Award quest bonuses
        state.treasury += q.rewardCash;
        addHistoryCallback(`🏆 QUEST COMPLETATA: "${q.title}"! (+§${q.rewardCash}, +${q.rewardXp} XP)`);

        this.addXp(state, q.rewardXp, addHistoryCallback);
      }
    });
  }

  /**
   * Adds XP and handles Mayoral level up thresholds and unlocks
   */
  public addXp(state: CityState, amount: number, addHistoryCallback: (msg: string) => void) {
    state.xp += amount;
    
    // Level-up loop
    while (state.xp >= state.xpNeeded) {
      state.xp -= state.xpNeeded;
      state.cityLevel += 1;
      state.xpNeeded = Math.round(state.cityLevel * 150); // Scale up requirement

      addHistoryCallback(`🌟 LIVELLO MAYOR AUMENTATO: Raggiunto il Livello ${state.cityLevel}!`);
      
      // Update unlocked densities based on Mayoral Level
      if (state.cityLevel === 2) {
        state.unlockedDensities = ['low', 'medium'];
        addHistoryCallback(`🔓 SBLOCCATO: Sbloccate le ZONIZZAZIONI MEDIE (Condomini e Uffici)!`);
      } else if (state.cityLevel >= 3) {
        state.unlockedDensities = ['low', 'medium', 'high'];
        addHistoryCallback(`🔓 SBLOCCATO: Sbloccate le ZONIZZAZIONI ALTE (Grattacieli e Raffinerie)!`);
      }
    }
  }
}
